import { HeartIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';

function Footer() {
  const lastUpdate = '15/02/2025'; // Mantener actualizada esta fecha
  const version = 'v1.0.0'; // Versión del sistema

  return (
    <footer className="py-6 border-t border-secondary-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Información del sistema */}
          <div className="flex flex-col items-center md:items-start gap-1">
            <div className="text-sm text-secondary-600">
              Última actualización: <span className="font-medium">{lastUpdate}</span>
            </div>
            <div className="text-sm text-secondary-600">
              Versión: <span className="font-medium">{version}</span>
            </div>
          </div>

          {/* Enlaces y recursos */}
          <div className="flex flex-wrap justify-center gap-6">
            <a
              href="https://github.com/reynergonzalez"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-secondary-600 hover:text-primary-600 transition-colors flex items-center gap-1"
            >
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
              </svg>
              GitHub
            </a>
            <Link
              to="/terminos"
              className="text-sm text-secondary-600 hover:text-primary-600 transition-colors"
            >
              Términos de uso
            </Link>
            <Link
              to="/privacidad"
              className="text-sm text-secondary-600 hover:text-primary-600 transition-colors"
            >
              Política de privacidad
            </Link>
          </div>

          {/* Créditos */}
          <div className="text-sm text-secondary-600">
            Desarrollado por{' '}
            <a
              href="https://reynergonzalez.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              Reyner González
            </a>
          </div>
        </div>

        {/* Mensaje de código abierto */}
        <div className="mt-4 text-center text-xs text-secondary-500">
          Este proyecto es de código abierto y está disponible en GitHub.
          Las contribuciones son bienvenidas.
        </div>
      </div>
    </footer>
  );
}

export default Footer; 